export default __webpack_public_path__ + "static/media/fileUploadIcon.15cff201.svg";